import { flexRender } from "@tanstack/react-table"
import { ReactElement } from "react"
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md"
import { twMerge } from "tailwind-merge"
import { TableHeaderProps } from "../TableHeader"

export function TableHeaderMapPage<T>(props: TableHeaderProps<T>): ReactElement {
	return (
		<>
			{props.headerGroups.map((headerGroup) => (
				<div
					id="header-map-page"
					key={headerGroup.id}
					className={twMerge(
						`mb-3 grid h-3 text-[10px] leading-3 font-bold tracking-[0.5px] uppercase select-none ${props.columnsLayout}`,
						props.className
					)}
				>
					{headerGroup.headers.map((header) => (
						<div key={header.id}>
							<div
								className={`relative flex h-full flex-row items-center ${
									header.column.getCanSort() === true
										? `cursor-pointer select-none`
										: ``
								}`}
								onClick={header.column.getToggleSortingHandler()}
							>
								<span
									className={`${
										header.column.getIsSorted() === "desc" ||
										header.column.getIsSorted() === "asc"
											? "text-dipai-text-highlight"
											: "text-dipai-text-primary"
									} hover:text-dipai-text-highlight h-full w-auto py-0`}
								>
									{header.isPlaceholder === true
										? null
										: flexRender(
												header.column.columnDef.header,
												header.getContext()
											)}
								</span>
								<div className="text-dipai-text-highlight -mt-1">
									{header.column.getIsSorted() === "desc" ? (
										<MdKeyboardArrowDown className="size-5" />
									) : header.column.getIsSorted() === "asc" ? (
										<MdKeyboardArrowUp className="size-5" />
									) : null}
								</div>
							</div>
						</div>
					))}
				</div>
			))}
		</>
	)
}
